import { takeLatest, put, call,take } from 'redux-saga/effects';
import fileSaver from 'file-saver';
import { toast } from 'react-toastify';
import { HTTP_HEADERS, HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants';
import request from '../../components/Utils/httpHelper';
import * as DataListActions from './action';
import { INTEGRATION_SERVICE } from '../../config';

export function* dataUploadRequest(action){
    let requestURL = `${INTEGRATION_SERVICE}/data-upload/`;
    const formData = new FormData();
    formData.append('fileId', action.data.fileId);
    formData.append('filetype', action.data.filetype);
    try {
        const data = yield call(request, requestURL, { method: 'POST', data: formData, headers: HTTP_HEADERS});
        if(data && data.status == "200" ){
            yield put(DataListActions.dataUploadSuccess({ data : data.data , status : "SUCCESS"}));
        }else{
            yield put(DataListActions.dataUploadFailure({ data : data.data , status :  "FAILURE"}));
        }
    }
    catch (err) {
        yield put(DataListActions.dataUploadFailure( { ...err.response , status : "FAILURE"}))
    }
}
export function* uploadedDataList(action) {
    let requestUrl = `${INTEGRATION_SERVICE}/data-upload/list`;
    try {
        const listResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(DataListActions.getDataListSuccess(listResult.data));
    } catch (err) {
        yield put(DataListActions.getDataListFailure(err.response))
    }
}
export function* getDataList() {
    yield takeLatest(DataListActions.GET_DATA_LIST, uploadedDataList);
}
export function* dataUpload() {
    yield takeLatest(DataListActions.DATA_UPLOAD, dataUploadRequest);
}

export function* downloadStarRatingResultRequest(action) {
    const token = localStorage.getItem('id_token');
    if (!token) {
        toast.error(
            <div>
                <i className="fa fa-exclamation-triangle"></i>&nbsp;Please log in again to download the file
            </div>
        );
        return;
    }
    const requestUrl = `${INTEGRATION_SERVICE}/data-upload/result?recordId=${encodeURIComponent(action.recordId)}`;
    const headers = {
        ...HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER,
        Authorization: `Bearer ${token}`,
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream',
    };
    try {
        const result = yield call(request, requestUrl, {
            method: 'GET',
            headers,
            responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER,
        });
        const blob = new Blob([result.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        fileSaver.saveAs(blob, action.fileName);
    } catch (err) {
        toast.error(
            <div>
                <i className="fa fa-exclamation-triangle"></i>&nbsp;Unable to download result file
            </div>
        );
    }
}

export function* downloadStarRatingResult() {
    yield takeLatest(DataListActions.DOWNLOAD_STAR_RATING_RESULT, downloadStarRatingResultRequest);
}
